<template>
  <div>
    <Pane v-if="!inModal" :title="'添加物资采购记录'"/>

    <div :class="{ container: !inModal }">
      <PurchaseMaterialsForm
          ref="form"
          :detailData="detailData"
          @submit="handleSubmit"
          @close="handleClose"
      />
    </div>
  </div>
</template>

<script>
import PurchaseMaterialsForm from "./form.vue";
import {addOfficeApply} from "@/api/oa/purchaseMaterials";

export default {
  components: {PurchaseMaterialsForm},

  props: {
    inModal: {type: Boolean, default: false},
    detailData: {type: Object, default: null},
  },

  methods: {
    handleSubmit(payload) {
      this.$refs.form.setLoading(true);
      addOfficeApply(payload)
          .then(() => {
            this.$message.success("提交成功");
            this.$emit("success");
            this.handleClose();
          })
          .finally(() => {
            this.$refs.form.setLoading(false);
          });
    },

    handleClose() {
      if (this.inModal) {
        this.$emit("close");
      } else {
        this.$close(this.$route.path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}
</style>